import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import { isEmpty } from "../../utils/nativeUtils";
import { observer } from "mobx-react-lite";
import { WithSearch } from "@elastic/react-search-ui";
import { ReactComponent as CheckboxCheckedIcon } from "../../assets/icons/checkbox-checked.svg";
import { ReactComponent as CheckboxUncheckedIcon } from "../../assets/icons/checkbox-unchecked.svg";
import { UIStateStoreContext } from "../../stores/uiStateStore";
import { FacetTitle } from "./FacetTitle";
import { ShowMoreOptions } from "./ShowMoreOptions";
import { getSortedFacetOptions } from "../../utils/functions";
import { i18nConfig } from "../../i18nConfig";
import { injectIntl } from "react-intl";
const CheckboxOption = injectIntl(({ intl, option, onRemove, onSelect }) => {
    const checked = option.selected;
    const optionLabel = option.value === "Not version-specific"
        ? (!!i18nConfig.messages[intl.locale] &&
            i18nConfig.messages[intl.locale]["facets.software_version.notVersionSpecific"]) ||
            i18nConfig.messages[intl.defaultLocale]["facets.software_version.notVersionSpecific"]
        : option.value;
    function handleChange() {
        checked ? onRemove(option.value) : onSelect(option.value);
    }
    function handleKeyDown(event) {
        if (event.key === " " || event.key === "Enter") {
            event.preventDefault();
            handleChange();
        }
    }
    return (_jsxs("li", { className: "option", children: [_jsxs("label", { className: "checkbox", tabIndex: 0, onKeyDown: handleKeyDown, title: "Select option", children: [_jsxs("span", { className: "checkbox-input", "data-testid": `checkbox-selectFilter-${option.value}`, children: [_jsx("input", { type: "checkbox", name: "checkbox", value: option.value, "data-testid": `checkbox-${option.value}`, checked: checked, onChange: handleChange }), checked ? (_jsx(CheckboxCheckedIcon, {})) : (_jsx(CheckboxUncheckedIcon, {}))] }), _jsx("span", { className: "checkbox-label", "data-testid": `option-label-${option.value}`, children: optionLabel })] }), _jsx(WithSearch, { mapContextToProps: ({ results }) => ({ results }), children: ({ results }) => (_jsx(Fragment, { children: !isEmpty(results) && _jsx("span", { className: "facet-result-count small-text", children: option.count }) })) })] }));
});
const FacetContent = observer(({ labelKey, options, showMore, onRemove, onSelect, onMoreClick, }) => {
    const uiStore = useContext(UIStateStoreContext);
    const facetValue = uiStore.getAvailableFacets()?.find((value) => value.label === labelKey)?.field;
    const isOpen = !!facetValue && uiStore.isFacetOpen(facetValue);
    return (_jsx(WithSearch, { mapContextToProps: ({ filters, facets }) => ({ filters, facets }), children: ({ filters, facets }) => (_jsxs("div", { className: "sui-facet", "data-testid": `multiSelectFacet-${facetValue}`, children: [_jsx(FacetTitle, { titleKey: labelKey }), isOpen && (_jsxs(Fragment, { children: [_jsx("ul", { className: "options", children: !!facetValue && getSortedFacetOptions(facetValue, options, filters, facets).map((option, i) => {
                                return _jsx(CheckboxOption, { option: option, onRemove: onRemove, onSelect: onSelect }, i);
                            }) }), showMore && _jsx(ShowMoreOptions, { onShowMore: onMoreClick })] }))] })) }));
});
/**
 * Renders the custom multi selection facet.
 * @param label key for translating the name of the facet
 * @param options options for the facet
 * @param onSelect handles selecting an option
 * @param onRemove handles removing an option
 */
export const MultiSelectFacet = ({ label, options, showMore, onRemove, onSelect, onMoreClick, }) => {
    return (_jsx(FacetContent, { labelKey: label, options: options, onRemove: onRemove, onSelect: onSelect, showMore: showMore, onMoreClick: onMoreClick }));
};
